// extracted by mini-css-extract-plugin
export var pinnedwrap = "cardlist-module--pinnedwrap--Jdt8i";
export var blogContentPinned = "cardlist-module--blog-content-pinned--2yMzl";
export var avatarPinned = "cardlist-module--avatar-pinned--eDp3G";
export var postDetail = "cardlist-module--post-detail--cToe3";
export var tag = "cardlist-module--tag--CjYGt";
export var pinned = "cardlist-module--pinned--u1IPu";
export var cardlist = "cardlist-module--cardlist--zn6hK";
export var user = "cardlist-module--user--EY7GQ";
export var avatar = "cardlist-module--avatar--9qgzu";
export var descriptionWrap = "cardlist-module--description-wrap--jSBN0";
export var descriptionPinned = "cardlist-module--descriptionPinned--uca5I";
export var description = "cardlist-module--description--E-nUi";
export var descriptiontext = "cardlist-module--descriptiontext--wNk5g";